/*
 * @Author: Chao Yang
 * @Date: 2019-12-11 10:01:56
 * @LastEditor: Chao Yang
 * @LastEditTime: 2022-06-28 14:15:10
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProxyModule } from '../proxy/proxy.module';
import { AccountService, BankingService, DetailService } from './account/index';
import { ActivityService } from './activity/index';
import { DocumentService } from './document/index';
import { FolderService } from './folder/index';
import { FundService, FundTransactionService } from './fund/index';
import { LayoutService } from './layout/index';
import { PreferenceService } from './preference/index';
import { TaskService } from './task/index';
import { OfferingService } from './offering/offering.service';
import { OnboardingService } from './offering/onboarding.service';
import {
  MyInvestmentService,
  ConfigurationService,
  DashboardService,
} from './dashboard';
import { AggregateDataService } from './dashboard/aggregate/aggregateData.service';
import { CommonService } from './common/common.service';
import { PositionService } from './portfolio';
import { SessionService } from './session';
import { TransferStationService } from './transferStation';
import { DataRoomEditorService } from './offering/data-room-editor.service';
import { DataRoomService } from './offering/data-room.service';
import { MenuService } from './menu/menu.service';
// import { FeatureDrillDownInvestorTransactionService } from './feature/index';
import { DocumentViewerService } from './document-viewer/document-viewer.service';
import { BrandService } from './brand/index';
import { UserActionTrackerService } from './user-action-tracker';

@NgModule({
  declarations: [],
  imports: [CommonModule, ProxyModule],
  providers: [
    AccountService,
    BankingService,
    ActivityService,
    DetailService,
    DocumentService,
    FolderService,
    FundService,
    LayoutService,
    PreferenceService,
    OfferingService,
    TaskService,
    MyInvestmentService,
    ConfigurationService,
    AggregateDataService,
    DashboardService,
    CommonService,
    PositionService,
    SessionService,
    TransferStationService,
    OnboardingService,
    DataRoomEditorService,
    DataRoomService,
    MenuService,
    FundTransactionService,
    DocumentViewerService,
    BrandService,
    UserActionTrackerService,
  ],
})
export class ServiceModule { }
